import type { ComponentProps } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * An amount input with «€» after the figure, as on the board («48,50 €»). The sign is drawn beside
 * the value, never typed into it: the value stays the decimal string the form parses.
 */
export function EuroInput({ className, ...props }: ComponentProps<'input'>) {
  return (
    <div className="relative">
      <Input
        inputMode="decimal"
        autoComplete="off"
        className={cn('pr-8 text-right tabular-nums', className)}
        {...props}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-sm
          text-muted-foreground"
      >
        €
      </span>
    </div>
  );
}
